
import { ref, onMounted } from "vue";
import Header from "@/components/header/header.vue";
import Step1 from "./Step1.vue";
import Step2 from './Step2.vue'
import Step3 from './Step3.vue'
import { useRoute } from "vue-router";
import $http  from '@/plugins/http'
export default {
  components: {
    Header,
    Step1,
    Step2,
    Step3
  },
  setup(props: object) {
    const currentStep = ref(1)
    const $route:any = useRoute()
    const fromToken = ref('')
    const cancellationInfo = ref(null)
    const currentPage = (step: any) => {
      currentStep.value = step
      window.scrollTo(0, 0)
    }

    // lite 查询账户注销状态
    const checkAccountCancellationLite = async() => {
      const res = await $http.getAccountStateLite({'pfx-accesstoken': fromToken.value})
      if (res.data.cancellationState === 0 || res.data.cancellationState === 3) {
        currentStep.value = 1
      } else {
        currentStep.value = 3
      }
      cancellationInfo.value = res.data
    }

    // k 查询账户注销状态
    const checkAccountCancellationKili = async () => {
      const res = await $http.getAccountStateKili({ 'authorization': 'Bearer ' + fromToken.value })
      // 0 可注销 1-注销中 2-已注销  3-取消注销
      if (res.data.cancel_state === 0 || res.data.cancel_state === 3) {
        currentStep.value = 1
      } else {
        currentStep.value = 3
      }
      cancellationInfo.value = res.data.cancellationState
    }

    onMounted(() => {
      const { token, systype } = $route.query
      fromToken.value = token
      if (systype === 'lite') {
        checkAccountCancellationLite()
      } else {
        checkAccountCancellationKili()
      }
    })

    return {
      currentStep,
      cancellationInfo,
      currentPage,
      checkAccountCancellationLite,
      checkAccountCancellationKili
    }
  }
}
